import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  position: relative;
  background: white;
  border-radius: 8px;
  width: 1109px;
  max-width: 95vw;
  max-height: 90vh;
  overflow: hidden;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 64px;
  gap: 32px;
  margin: 0 auto;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  padding: 0;
`;

export const ModalTitle = styled.h2`
  color: ${({ theme }) => theme.color.gray[500]};
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 115%;
  margin: 0;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }

  img {
    width: 20px;
    height: 20px;
    opacity: 0.5;
  }

  &:hover img {
    opacity: 0.7;
  }
`;

export const ModalContent = styled.div`
  padding: 0;
  width: 100%;
  max-height: 70vh;
  overflow-y: auto;

  > p {
    color: ${({ theme }) => theme.color.gray[400]};
    margin: 0 0 20px 0;
    line-height: 1.5;
    font-size: 14px;
  }
`;

export const AssignedSubmissionSection = styled.div`
  margin-bottom: 24px;

  h3 {
    color: ${({ theme }) => theme.color.gray[500]};
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 115%;
    margin: 0 0 12px 0;
  }
`;

export const AssignedSubmissionCard = styled.div`
  border: 1px solid ${({ theme }) => theme.color.gray[250]};
  border-radius: 6px;
  background: #f8fafc;
  padding: 0;
`;

export const OtherSubmissionsSection = styled.div`
  h3 {
    color: ${({ theme }) => theme.color.gray[500]};
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 115%;
    margin: 0 0 16px 0;
  }
`;

export const SubmissionsTable = styled.div`
  border: 1px solid ${({ theme }) => theme.color.gray[150]};
  border-radius: 8px;
  background: white;
  overflow: hidden;
  width: 100%;
`;

export const TableHeader = styled.div`
  display: grid;
  grid-template-columns: 48px 1.5fr 1.6fr 0.8fr 2fr 1.2fr 1.2fr;
  background: #f8f9fa;
  border-bottom: 1px solid ${({ theme }) => theme.color.gray[150]};
  font-weight: 500;
  color: ${({ theme }) => theme.color.gray[400]};
  font-size: 14px;
  padding: 12px 0;
  width: 100%;
`;

export const TableRow = styled.div`
  display: grid;
  grid-template-columns: 48px 1.5fr 1.6fr 0.8fr 2fr 1.2fr 1.2fr;
  border-bottom: 1px solid ${({ theme }) => theme.color.gray[150]};
  padding: 8px 0;
  width: 100%;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f9fafb;
  }
`;

export const TableCell = styled.div`
  padding: 0 16px;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: ${({ theme }) => theme.color.gray[800]};
  width: 100%;
  min-height: 40px;
  overflow: hidden;

  span {
    display: inline-block;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const CheckboxCell = styled(TableCell)`
  justify-content: center;

  input[type='checkbox'] {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
`;

export const MatchBadge = styled.span<{ color: string }>`
  display: inline-block;
  padding: 4px 8px;
  background-color: ${({ color }) => color};
  color: ${({ theme }) => theme.color.gray[500]};
  border-radius: 4px;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%;
  margin-right: 8px;
  white-space: nowrap;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 16px;
  padding: 0;
  width: 100%;
  background: ${({ theme }) => theme.color.white};
  position: relative;
`;

export const CloseModalButton = styled.button`
  background: white;
  border: 1px solid ${({ theme }) => theme.color.gray[250]};
  color: ${({ theme }) => theme.color.gray[750]};
  padding: 12px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.25;

  &:hover {
    background: #f9fafb;
    border-color: ${({ theme }) => theme.color.gray[350]};
  }

  &:focus {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
  }
`;

export const MergeButton = styled.button<{ disabled?: boolean }>`
  background: ${({ theme, disabled }) => (disabled ? theme.color.gray[150] : '#60a5fa')};
  color: ${({ theme, disabled }) => (disabled ? theme.color.gray[350] : 'white')};
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-weight: 500;
  font-size: 14px;
  line-height: 1.25;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: ${({ theme, disabled }) => (disabled ? theme.color.gray[150] : '#3b82f6')};
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.color.blue[700]};
    outline-offset: 2px;
  }
`;

export const ErrorMessage = styled.div`
  color: ${({ theme }) => theme.color.red[500]};
  font-size: 14px;
  margin-right: 16px;
`;

export const PaginationFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 16px;
  background-color: rgba(74, 85, 104, 0.1);
  border-top: 1px solid ${({ theme }) => theme.color.gray[150]};
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;

export const PaginationLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: ${({ theme }) => theme.color.gray[400]};
`;

export const PaginationRight = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

export const PageInfo = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.color.gray[400]};
  font-weight: 500;
`;

export const PaginationButton = styled.button<{ disabled?: boolean }>`
  padding: 6px 10px;
  border: none;
  border-radius: 4px;
  background: none;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-size: 14px;
  color: ${({ theme }) => theme.color.gray[750]};
  min-width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.color.gray[100]};
  }
`;

export const PageSizeSelect = styled.select`
  padding: 4px 8px;
  border: none;
  border-radius: 4px;
  background: none;
  font-size: 14px;
  color: ${({ theme }) => theme.color.gray[750]};
  cursor: pointer;

  &:focus {
    outline: 2px solid #3b82f6;
    outline-offset: 2px;
  }
`;

export const EntryWrapper = styled.div`
  font-size: 20px;
  color: ${({ theme }) => theme.color.gray[500]};
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-left: 1rem;
`;

export const MatchesGridContainer = styled.div`
  width: 100%;

  .ag-body-viewport {
    overflow: hidden !important;
  }

  .ag-center-cols-viewport {
    overflow: hidden !important;
  }

  .ag-header-cell {
    padding: 0 !important;
  }

  .ag-header-cell-label {
    padding-left: 8px !important;
    padding-right: 8px !important;
    justify-content: flex-start !important;
    width: 100% !important;
    color: rgba(74, 85, 104, 1) !important;
    font-size: 14px !important;
    font-style: normal !important;
    font-weight: 600 !important;
    line-height: 115% !important;
    display: flex !important;
    align-items: center !important;
    height: 100% !important;
  }

  .center-header .ag-header-cell-label {
    justify-content: center !important;
  }

  .center-cell {
    text-align: center !important;
    justify-content: center !important;
  }

  .ag-cell {
    color: rgba(74, 85, 104, 1) !important;
  }

  .ag-cell span {
    color: rgba(74, 85, 104, 1) !important;
  }
`;

export const ThisSubmissionWrapper = styled.div`
  display: flex;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  height: 105px;
  padding: 1rem;
`;

export const AssignedRowContainer = styled.div`
  width: 100%;
  height: 40px;
  background-color: rgba(74, 85, 104, 0.1);
  border: 1px solid ${({ theme }) => theme.color.gray[200]};
  border-radius: 8px;
  margin-bottom: 32px;
  display: flex;
  align-items: center;
`;

export const AssignedRowCell = styled.div<{ width: string }>`
  width: ${({ width }) => width};
  display: flex;
  align-items: center;
  height: 100%;
`;

export const AssignedRowCheckboxCell = styled(AssignedRowCell)`
  justify-content: center;
`;

export const AssignedRowTextCell = styled(AssignedRowCell)`
  color: rgba(74, 85, 104, 1);
  font-size: 14px;
  overflow: hidden;
  padding-left: 12px;
  padding-right: 12px;
  font-weight: normal;
`;

export const AssignedRowNameCell = styled.div`
  width: 195px;
  display: flex;
  align-items: center;
  height: 100%;
  color: rgba(74, 85, 104, 1);
  font-size: 14px;
  overflow: hidden;
  padding-left: 12px;
  padding-right: 12px;
  font-weight: 500;
`;

export const AssignedRowPropertyCell = styled.div`
  width: 180px;
  display: flex;
  align-items: center;
  height: 100%;
  color: rgba(74, 85, 104, 1);
  font-size: 14px;
  overflow: hidden;
  padding-left: 12px;
  padding-right: 12px;
  font-weight: normal;
`;

export const AssignedRowEmailCell = styled.div`
  width: 220px;
  display: flex;
  align-items: center;
  height: 100%;
  color: rgba(74, 85, 104, 1);
  font-size: 14px;
  overflow: hidden;
  padding-left: 20px;
  padding-right: 12px;
  font-weight: normal;
`;

export const AssignedRowPhoneCell = styled.div`
  width: 150px;
  display: flex;
  align-items: center;
  height: 100%;
  color: rgba(74, 85, 104, 1);
  font-size: 14px;
  overflow: hidden;
  padding-left: 20px;
  padding-right: 12px;
  font-weight: normal;
`;

export const AssignedRowAppliedCell = styled.div`
  width: 130px;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
`;

export const AssignedRowEmptyCell = styled.div`
  width: 100px;
  display: flex;
  align-items: center;
  height: 100%;
`;

export const AssignedRowDocCell = styled.div`
  width: 60px;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
`;

export const AssignedRowCheckboxCellStyled = styled.div`
  width: 56px;
  display: flex;
  align-items: center;
  height: 100%;
  justify-content: center;
`;

export const AssignedRowCenterCell = styled(AssignedRowCell)`
  justify-content: center;
`;

export const AssignedRowTextSpan = styled.span`
  display: inline-block;
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const AssignedRowDocButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const AppliedWrapper = styled.div`
  display: flex;
  font-style: italic;
  font-weight: 500;
  font-size: 14px;
`;

export const EntrySubtext = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.color.gray[500]};
  font-weight: 400;
`;

export const ModalDescription = styled.p`
  margin: 8px 0 0 0;
  color: ${({ theme }) => theme.color.gray[500]};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 130%;
`;

export const ErrorMessageAbsolute = styled(ErrorMessage)`
  position: absolute;
  left: 64px;
`;

export const CenteredCheckContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

// New styled components for MatchesDataGrid
export const GridCellContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const GridDocButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const GridCellStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
} as const;

export const GridStyle = {
  '--ag-border-color': 'transparent',
  '--ag-row-border-color': 'transparent',
  '--ag-header-background-color': 'rgba(74, 85, 104, 0.1)',
  '--ag-header-foreground-color': 'white',
  '--ag-odd-row-background-color': 'rgba(74, 85, 104, 0.1)',
  '--ag-even-row-background-color': 'white'
} as const;
